import {
  ActionPlansApi,
  Configuration,
  CustomersApi,
  DefaultApi,
  ScenariosApi,
  SpendsApi,
  ValidationApi,
} from "@mutiny-group/sbo-openapi-client";

import { EnvVar } from "@/env";

export class ScenarioBuilderClient {
  private config: Configuration;
  private baseURL: string;

  constructor() {
    this.baseURL = EnvVar.sboUrl;
    this.config = new Configuration({
      basePath: this.baseURL,
    });
  }

  // Setup auth interceptor for all API clients
  setupAuthInterceptor(getAccessToken: () => Promise<string>, onUnauthorized: () => void) {
    // Update configuration to include auth interceptors
    this.config = new Configuration({
      basePath: this.baseURL,
      accessToken: getAccessToken,
      middleware: [
        {
          pre: async (context: any) => {
            const token = await getAccessToken();
            context.init.headers = {
              ...context.init.headers,
              Authorization: `Bearer ${token}`,
            };
            return context;
          },
          post: async (context: any) => {
            // Handle 401 responses
            if (context.response.status === 401) {
              onUnauthorized();
            }
            return Promise.resolve(context.response);
          },
        },
      ],
    });
  }

  get scenarios() {
    return new ScenariosApi(this.config);
  }

  get customers() {
    return new CustomersApi(this.config);
  }

  get validation() {
    return new ValidationApi(this.config);
  }

  get default() {
    return new DefaultApi(this.config);
  }

  get spends() {
    return new SpendsApi(this.config);
  }

  get actionPlans() {
    return new ActionPlansApi(this.config);
  }

  // For backwards compatibility with existing async pattern
  async getApi() {
    return {
      scenarios: this.scenarios,
      customers: this.customers,
      validation: this.validation,
      default: this.default,
      spends: this.spends,
      actionPlans: this.actionPlans,
    };
  }
}
